import React, { useLayoutEffect, useRef } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { TAttachmentOnClient } from '@entities/attachment/model/types';
import { FileItemImg } from '@entities/attachment/ui/FileItem/FileItemImg';
import { FileItemSvg } from '@entities/attachment/ui/FileItem/FileItemSvg';
import { isImg } from '@shared/helpers';
import { CircularLoader, Flex, Input, UiButton } from '@shared/ui';
import { useOrdersRecognitionContext } from '@widgets/OrdersRecognition/lib/hooks';

import cls from './FilePreload.module.css';

interface IFilePreloadProps {
    droppedFiles: TAttachmentOnClient[];
    fileId: number;
    comment: string;
    isLoading: boolean;
    onChangeComment: (inputValue: string) => void;
    onSubmitHandler: () => void;
    imgUrl?: string;
    fileName?: string;
    fileExtension?: string;
    className?: string;
    fileClassName?: string;
}
export const FilePreload = ({
    droppedFiles,
    fileId,
    comment,
    isLoading,
    onSubmitHandler,
    onChangeComment,
    imgUrl,
    fileName,
    fileExtension,
    className,
    fileClassName,
}: IFilePreloadProps) => {
    const { t } = useTranslation();
    const ref = useRef(null);
    const { onShowLightBox } = useOrdersRecognitionContext();

    useLayoutEffect(() => {
        if (!isLoading) {
            ref.current?.focus();
        }
    }, [isLoading, fileId]);

    const filesForLightbox = droppedFiles.map((attachment) => ({
        id: attachment.id,
        fileSrc: URL.createObjectURL(attachment.file),
        mimeType: attachment.file.type,
        fileName: attachment.file.name,
    }));

    const isImage = isImg(droppedFiles[0]?.file?.type);

    return (
        <Flex justify="between" fullWidth className={cn(cls.FilePreloadContainer, className)}>
            <Flex gap={18} align="center">
                {isLoading && <CircularLoader size={28} />}
                {/* <CircularLoader size={30} /> */}

                {!isLoading && isImage && (
                    // <div onClick={() => onShowLightBox({id, []})}>
                    <span
                        className={cn(cls.fileItemContainer, fileClassName)}
                        title={fileName}
                        onClick={() =>
                            onShowLightBox({
                                id: fileId,
                                newFiles: filesForLightbox,
                            })
                        }
                    >
                        <FileItemImg imgUrl={imgUrl} fileName={fileName} />
                    </span>
                    // </div>
                )}
                {!isLoading && !isImage && (
                    <div
                        title={fileName}
                        onClick={() =>
                            onShowLightBox({
                                id: fileId,
                                newFiles: filesForLightbox,
                            })
                        }
                        className={cn(cls.fileItemContainer, fileClassName)}
                    >
                        <FileItemSvg extension={fileExtension} iconWidth={30} iconHeight={30} />
                    </div>
                )}

                <Input
                    placeholder={t('OrderRecognition.FilePreload.Input.placeholder')}
                    maxLength={1000}
                    inputClassName={cls.commentInput}
                    disabled={isLoading}
                    value={comment}
                    onChange={(e) => onChangeComment(e.target.value)}
                    innerRef={ref}
                />
            </Flex>

            <UiButton
                btnColor="success"
                btnText="Сохранить"
                onClick={onSubmitHandler}
                disabled={isLoading}
            />
        </Flex>
    );
};
